import { render, staticRenderFns } from "./BookMetaAddForm.vue?vue&type=template&id=5fe15030&"
import script from "./BookMetaAddForm.vue?vue&type=script&lang=js&"
export * from "./BookMetaAddForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports